import { FormattedDate, FormattedMessage } from 'react-intl';

// eslint-disable-next-line local/no-messages-import -- dynamic weekday names via IwDynamicFormattedMessage
import messages from './RepaymentSummaryItem.messages';
import styles from './RepaymentSummaryItem.module.css';
import { IwDynamicFormattedMessage } from '../../../iwDynamicFormattedMessage/IwDynamicFormattedMessage';
import { MoneyWithDecimals } from '../moneyWithDecimals';

const RepaymentSummaryItem = ({
    amount,
    description,
    interval,
    value
}: {
    amount: number | null;
    description: React.ReactNode;
    value: string | number | null;
    interval?: string;
}) => {
    return (
        <div className={styles.RepaymentSummaryItem}>
            <div className={styles.nextRepaymentContainer}>
                <div className={styles.nextRepaymentLabel}>
                    <FormattedMessage
                        id="_.next_repayment_summary.label"
                        defaultMessage="Next repayment"
                    />
                </div>

                {amount !== null && (
                    <div className={styles.nextRepaymentDate}>
                        <RepayDate interval={interval} value={value} />
                    </div>
                )}
            </div>

            <div className={styles.amountLine}>
                <MoneyWithDecimals
                    integerWithSymbolClassName={styles.RepayMoneyInteger}
                    decimalWithSeparatorClassName={styles.RepayMoneyDecimals}
                    className={styles.RepayMoney}
                    value={amount!}
                />
            </div>

            {description && (
                <div className={styles.RepayDescription}>{description}</div>
            )}
        </div>
    );
};

// eslint-disable-next-line
export default RepaymentSummaryItem;

const RepayDate = ({
    value,
    interval
}: {
    value: string | number | null;
    interval?: string;
}) => {
    if (!value) {
        return null;
    }

    /* eslint-disable local/no-spread-messages -- dynamic weekday/monthly lookup */
    switch (interval) {
        case 'Weekly':
            const dayOfWeek = [
                'Monday',
                'Tuesday',
                'Wednesday',
                'Thursday',
                'Friday',
                'Saturday',
                'Sunday'
            ][value as number];

            const weekDay = (
                <IwDynamicFormattedMessage
                    messages={messages}
                    messageKey={dayOfWeek}
                />
            );
            return (
                <div className={styles.RepayDate}>
                    <FormattedMessage
                        {...messages.weekly}
                        values={{ weekDay }}
                    />
                </div>
            );

        case 'Monthly':
            return (
                <div className={styles.RepayDate}>
                    <FormattedMessage
                        {...messages.monthly}
                        values={{ monthDay: value }}
                    />
                </div>
            );
        /* eslint-enable local/no-spread-messages */

        default:
            return (
                <FormattedDate
                    day="numeric"
                    month="long"
                    year="numeric"
                    value={new Date(value)}
                />
            );
    }
};
